import Breadcrumbs from "../../../components/shared/Breadcrumbs/Breadcrumbs";
import CreateReportButton from "../../../components/shared/Reports/CreateReportButton";
import { ButtonsWrapper, PageContainer } from "../../../styled";
import { useForm } from "react-hook-form";

const VesselReports = () => {
  return (
    <PageContainer>
      <Breadcrumbs border={false}>
        <ButtonsWrapper>
          <CreateReportButton redirectUrl="/management/reports/add-report" />
        </ButtonsWrapper>
      </Breadcrumbs>
    </PageContainer>
  );
};
export default VesselReports;
